import { render, staticRenderFns } from "./PromotionApproval.vue?vue&type=template&id=92b54ebe&scoped=true"
import script from "./PromotionApproval.vue?vue&type=script&lang=js"
export * from "./PromotionApproval.vue?vue&type=script&lang=js"
import style0 from "./PromotionApproval.vue?vue&type=style&index=0&id=92b54ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b54ebe",
  null
  
)

export default component.exports